import Vue from 'vue'
import VueTippy, { TippyComponent } from 'vue-tippy'
import 'tippy.js/themes/light-border.css'

Vue.use(VueTippy, {
  arrow: true,
  duration: 300,
  theme: 'light-border'
})

Vue.component('tippy', TippyComponent)

export default Vue
